module.exports = __webpack_public_path__ + "img/5.291f0ff0.png";